import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/shipPort'

export function getAllShipPort() {
    return request({
        url:`${BASE_REQUEST}/getAllShipPort`
    })
}

export function getAllShipPortName() {
  return request({
      url:`${BASE_REQUEST}/getAllShipPortName`
  })
}
